<template>
  <v-row v-if="answers && answers.length">
    <v-col class="title pb-0">
      Answers:
    </v-col>
    <v-col
      v-for="(item, index) in answers"
      cols="12"
      :key="index"
    >
      <div class="subtitle-1 font-weight-bold d-flex align-center">
        <ScreeningQuestionIcon
          class="mr-1"
          :type="item.type"
          :small="true"
        /> {{ item.question }}
      </div>
      <div class="subtitle-2">
        <template v-if="item.type === 'file'">
          <a
            class="link"
            :href="item.answer"
            download
          >
            Download attachment
          </a>
        </template>
        <template v-else-if="item.type === 'multiChoice'">
          <div
            v-for="(answer, i) in item.answer.split(';')"
            :key="i"
          >
            {{ answer }}
          </div>
        </template>
        <template v-else>
          {{ item.answer }}
        </template>
      </div>
    </v-col>
  </v-row>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import ScreeningQuestionIcon from '@/components/screeningQuestions/ScreeningQuestionIcon.vue'
import { IApplicationAnswer } from '@/types/models/application.model'

@Component({
  components: {
    ScreeningQuestionIcon
  }
})
export default class ScreeningQuestionsAnswers extends Vue {
  @Prop({ required: true, default: [] }) answers: IApplicationAnswer[]
}
</script>
